import React from 'react';
import classes from './Input.css';

const input = ( props ) => {
    let inputElement = null;
    let inputClasses = [classes.InputElement];
    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
    }
    switch (props.elementType) {
        case ('hidden'):
            break;
        case ( 'input' ):
            inputElement = <div><label>{props.elementConfig.placeholder}</label>
                <input
                    className={inputClasses.join(' '), '  form-control '}
                    {...props.elementConfig}
                    value={props.value}
                    onChange={props.changed}
                    disabled={props.textdisabled}
                />
                </div>;
            break;
        case ( 'textarea' ):
            inputElement = <textarea
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case ( 'select' ):
            inputElement = <div><label>{props.elementConfig.placeholder}</label>
                <select
                    className={inputClasses.join(' '), '  form-control '}
                    {...props.elementConfig}
                    value={props.value}
                    onChange={props.changed}>
                    {props.elementConfig.options.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.displayValue}
                        </option>
                    ))}
                </select>
            </div>
            break;
        default:
            inputElement = <input
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
    }

    return (
        <span className={classes.Input}>
            <label className={classes.Label}>{props.label}</label>
            {inputElement}
        </span>
    );

};

export default input;